import "./assets/css/main.css";
import { useMemo, lazy, useEffect, useState, startTransition } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";

import PrivateRoute from "./PrivateRoute";
import PreLoader from "./components/General/PreLoader";

import { LogoProvider } from "./context/LogoContext";
import { CreateTabProvider } from "./context/CreateTabContext";
import { PreLoaderProvider } from "./context/PreloaderContext";
import { SweetAlertProvider } from "./context/SweetAlertContext";
import { ToastProvider } from "./context/ToastContext";
import { UserTokenProvider } from "./context/UserTokenContext";
import { BrandProvider } from "./context/BrandContext";
import { CustomerProvider } from "./context/CustomerContext";
import { DownloadProvider } from "./context/DownloadContext";
import { UploadProvider } from "./context/UploadContext";
import { SignalRProvider } from "./context/signalRContext";
// import { HybridCallProvider } from "./context/HybridCallContext";

const AuthContainer = lazy(() => import("./containers/AuthContainer"));
const DashboardContainer = lazy(() =>
  import("./containers/DashboardContainer")
);

const ActivityBoardList = lazy(() =>
  import("./components/Clipboards/ActivityBoard/ActivityBoardList")
);

function App() {
  // THEME
  const globalTheme = useTheme();
  const AITheme = useMemo(
    () =>
      createTheme({
        overrides: {},
        palette: {
          primary: {
            main: "#ff5b05",
            // light: will be calculated from palette.primary.main,
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
          },
          secondary: {
            main: "#E0C2FF",
            light: "#F5EBFF",
            // dark: will be calculated from palette.secondary.main,
            contrastText: "#47008F",
          },
        },
        typography: {
          fontFamily: "Inter",
          fontWeight: "500",
          fontSize: 13,
          color: "#30363f",
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "0.875rem",
          },
        },
        components: {
          MuiAutocomplete: {
            styleOverrides: {
              input: {
                height: "15px",
                padding: "0",
              },

              // Name of the slot
              root: {
                "& $notchedOutline": {
                  borderColor: "green",
                },
                "&:hover $notchedOutline": {
                  borderColor: "red",
                },
                "&$focused $notchedOutline": {
                  border: "1px solid red",
                },
                "&&& $input": {
                  padding: "1px",
                  height: "48px",
                },
              },
            },
          },
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "11px", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );
  //

  // const getLanguageFile = async () => {
  //   axios
  //     .get(`${apiUrl}/getAll`)
  //     .then((response) => console.log("app response -->", response))
  //     .catch((error) => console.log("app error -->", error));
  // };

  // useEffect(() => {
  //   // startTransition(() => {
  //   getLanguageFile();
  //   // });
  // }, []);

  return (
    <PreLoaderProvider>
      <LogoProvider>
        <UserTokenProvider>
          <SweetAlertProvider>
            <ToastProvider>
              <BrandProvider>
                <ThemeProvider theme={AITheme}>
                  <CustomerProvider>
                    <CreateTabProvider>
                      <DownloadProvider>
                        <UploadProvider>
                          <SignalRProvider>

                            {/* <HybridCallProvider> */}
                            <Router>
                              <Routes>
                                <Route
                                  path="/"
                                  excat
                                  element={<AuthContainer />}
                                />
                                <Route
                                  path="/dashboard"
                                  element={
                                    <PrivateRoute>
                                      <DashboardContainer />
                                    </PrivateRoute>
                                  }
                                />
                                <Route
                                  path="/activityboard/:password"
                                  element={<ActivityBoardList />}
                                />
                              </Routes>
                            </Router>
                          </SignalRProvider>
                          {/* </HybridCallProvider> */}
                        </UploadProvider>
                      </DownloadProvider>
                    </CreateTabProvider>
                  </CustomerProvider>
                </ThemeProvider>
              </BrandProvider>
            </ToastProvider>
          </SweetAlertProvider>
        </UserTokenProvider>
      </LogoProvider>
      <PreLoader />
    </PreLoaderProvider>
  );
}

export default App;
